import { InjectionToken } from '@angular/core';

export interface LayoutConfig {
  copyright?: string;
}

export const LAYOUT_CONFIG = new InjectionToken<LayoutConfig>('Layout data');

export const provideLayoutConfig = (data: LayoutConfig) => [
  { provide: LAYOUT_CONFIG, useValue: data },
];
